import React from 'react';
import { InboxOutlined } from '@ant-design/icons';

// Shared "nothing here" placeholder for list pages and detail-page tabs —
// a bare text line read as a stuck/broken page rather than a normal, expected
// empty result. List pages center it under a wide grid; tab panes (Movies/
// Winners/Nominations) sit under left-aligned tab labels, so `align="left"`
// keeps it in line with them instead of floating in the middle of the row.
const EmptyState = ({ message, align = 'center' }) => (
    <div className={`__no_results ${align === 'left' ? '__no_results_left' : ''}`}>
        <InboxOutlined />
        <p>{message}</p>
    </div>
);

export default EmptyState;
